import React from 'react';
import { DefaultTokenProvider, AuthenticationToken } from 'infrastructure/security/authentication/DefaultTokenProvider';
import useAuthenticationTokenRepository from 'infrastructure/security/authentication/tokenprovider/authenticationTokenRepository';

const DefaultTokenProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  const { getToken } = useAuthenticationTokenRepository();

  const getAccessToken = async (): Promise<AuthenticationToken> => {
    const token = await getToken();

    return token?.token || null;
  };

  return <DefaultTokenProvider getToken={getAccessToken}>{children}</DefaultTokenProvider>;
};

export default DefaultTokenProviderWrapper;
